import { useEffect, useRef } from "react";
import { useCreateInvestmentOverlay } from "@/presentation/pages/investments/hooks/useCreateInvestmentOverlay";
import { useCreateInvestmentStore } from "@/stores/useCreateInvestmentStore";

export function CreateInvestmentHost() {
  const request = useCreateInvestmentStore((state) => state.request);
  const handleConsumed = useCreateInvestmentStore((state) => state.close);
  const create = useCreateInvestmentOverlay();
  const openDialog = useRef(create.open);
  useEffect(() => {
    openDialog.current = create.open;
  });
  useEffect(() => {
    if (!request) return;
    openDialog.current(request.state ?? null, request.investor ?? null, {
      beneficiary: request.beneficiary,
      quotaUuid: request.quotaUuid,
      amount: request.amount,
    });
    handleConsumed();
  }, [request, handleConsumed]);
  return create.dialog;
}
